import styled, { keyframes } from "styled-components";

const slideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const ModalWrapper = styled.div<{ $isTransparent?: boolean }>`
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ $isTransparent }) => $isTransparent ? "transparent" : "rgba(0, 0, 0, 0.2)"};
    backdrop-filter: ${({ $isTransparent }) => $isTransparent ? "none" : "blur(4px)"};
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
    padding: 32px 16px;
`;

export const ModalContent = styled.div<{ $maxWidth?: string, $minWidth?: string }>`
    width: 100%;
    max-width: ${({ $maxWidth }) => $maxWidth || "1250px"};
    max-height: calc(100vh - 64px);
    background: white;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    animation: ${slideUp} 0.2s ease-out;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0, 0, 0, 0.10);
`;

export const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 1.2rem 2.4rem;
    background: ${({ theme }) => theme.colors.appBlack};
    color: white;
    border-radius: 8px 8px 0 0;
    font-weight: 600;
`;

export const ModalBody = styled.div<{ $minHeight?: string, $minWidth?: string }>`
    padding: 2.4rem;
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
    flex: 1;
    min-height: 0;
`;

export const ModalFooter = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1.6rem;
    padding: 1.2rem 2.4rem;
    border-top: 1px solid #c2c4c6;
    border-radius: 0 0 8px 8px;
    bottom: 0;
    left: 0;
    width: 100%;
    background: white;
`;

export const Section = styled.div<{ $width?: string, $align?: string }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: ${({ $align }) => $align || "flex-start"};
`;

export const Row = styled.div<{ $justifyContent?: string, $width?: string, $marginTop?: string }>`
    display: flex;
    min-width: ${({ $width }) => $width || "auto"};
    width: 100%;
    gap: 0.8rem;
    align-items: center;
    justify-content: ${({ $justifyContent }) => $justifyContent || "space-between"};
    margin-top: ${({ $marginTop }) => $marginTop || "0"};
`;

export const Title = styled.h2`
    font-size: 1.4rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.titleColor};
`;

export const SmallText = styled.p<{ $marginBottom?: string }>`
    margin-bottom: ${({ $marginBottom }) => $marginBottom || "0"};
    font-size: 1.2rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.placeholderColor};
`;

export const Divider = styled.div`
    width: 100%;
    height: 1px;
    background: ${({ theme }) => theme.colors.selectionBlue};
`;

export const ConfirmationModalSubHeader = styled.h3`
    font-size: 1.4rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.lightOrange};
`;

export const ConfirmationModalTitle = styled.h2`
    font-size: 1.6rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.titleColor};
`;

export const ConfirmationModalBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
`;

export const ConfirmationModalText = styled.p`
    font-size: 1.4rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.textPrimary};
`;